import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function ForWhom() {
  const headerReveal = useScrollReveal({ threshold: 0.2 });
  const listReveal = useScrollReveal({ threshold: 0.1 });
  
  const targetAudience = [
    "jautiesi pasimetęs ir nori aiškumo",
    "nori daugiau energijos ir mažiau atidėliojimo",
    "nori pagerinti santykius ir suprasti partnerį",
    "nori susigrąžinti balansą (mintys–emocijos–rutina)",
    "nori jaustis labiau \"savimi\""
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16" ref={headerReveal.ref}>
          <div className={`inline-block mb-6 ${headerReveal.isVisible ? 'opacity-100 animate-fade-in-up stagger-1' : 'opacity-0'}`}>
            <span className="text-purple-600 font-semibold text-sm tracking-wider uppercase">
              KAM ŠI KNYGA SKIRTA?
            </span>
          </div>
          <h2 className={`font-serif text-5xl font-bold text-gray-900 mb-6 ${headerReveal.isVisible ? 'opacity-100 animate-fade-in-up stagger-2' : 'opacity-0'}`}>
            Ši Knyga Tau, Jei…
          </h2>
        </div>

        {/* Target audience list with staggered reveal */}
        <div className="space-y-4 mb-12" ref={listReveal.ref}>
          {targetAudience.map((item, index) => (
            <div 
              key={index}
              className={`flex items-start gap-4 bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-2xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 relative overflow-hidden group ${listReveal.isVisible ? `opacity-100 animate-fade-in-left stagger-${index + 1}` : 'opacity-0'}`}
            >
              {/* Gradient shift on hover */}
              <div className="absolute inset-0 bg-gradient-to-r from-purple-100 to-pink-100 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 relative z-10 ${listReveal.isVisible ? `animate-bounce-in stagger-${index + 2}` : ''}`}>
                <i className="ri-checkbox-circle-fill text-2xl text-purple-600"></i>
              </div>
              <p className="text-lg text-gray-800 leading-relaxed pt-0.5 relative z-10">
                {item}
              </p>
            </div>
          ))}
        </div>

        {/* Not for */}
        <div className={`bg-gray-50 border-2 border-gray-200 rounded-2xl p-8 text-center ${listReveal.isVisible ? 'opacity-100 animate-scale-in stagger-7' : 'opacity-0'}`}>
          <div className="flex items-center justify-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
              <i className="ri-close-circle-fill text-3xl text-gray-400"></i>
            </div>
            <p className="text-lg text-gray-700">
              <span className="font-semibold">Neskirta,</span> jei ieškai sausos teorijos be praktinių žingsnių.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
